import { SET_TOP_TO_BOTTOM_FILTER_SELECTION } from '../actionTypes/SelectionFilterTypes';

const initialState = {
    isTopToBottomFilterSelection: true,
};

const selectionFilter = function selectionFilter(state = initialState, action) {
    switch (action.type) {
        case SET_TOP_TO_BOTTOM_FILTER_SELECTION:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

selectionFilter.reducerName = 'selectionFilter';

export default selectionFilter;
